import { MilliswiftLogo, cn } from '@milliswift/ui'
import { Link } from 'react-router-dom'

/**
 * Centred card used by every auth page: logo, title, and the form.
 * No navigation chrome — these pages want total focus on one task.
 */
export function AuthCard({
  title,
  subtitle,
  children,
  footer,
  className,
}: {
  title: string
  subtitle?: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
  className?: string
}) {
  return (
    <div className={cn('w-full max-w-md', className)}>
      <div className="rounded-card border border-line bg-surface p-8 shadow-raised">
        <Link to="/login" aria-label="milliswift" className="mx-auto flex w-fit">
          <MilliswiftLogo height={30} />
        </Link>

        <h1 className="mt-8 text-center text-title font-semibold tracking-tight text-foreground">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-2 text-center text-sm text-muted">{subtitle}</p>
        ) : null}

        <div className="mt-8">{children}</div>
      </div>

      {footer ? <div className="mt-5 text-center text-sm text-muted">{footer}</div> : null}
    </div>
  )
}

/** Backs out of a centered card into a page shell. */
export function AuthPage({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-background px-4 py-12">
      {children}
    </div>
  )
}
